export const downloadFile = async (res: any, name: string, type: 'pdf' | 'xlsx' | 'zip' = 'xlsx') => {
    const mimeTypes: { [key: string]: string } = {
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8',
        pdf: 'application/pdf;charset=utf-8',
    };

    const blob = new Blob([res], { type: mimeTypes[type] });
    const blobURL = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('type', 'hidden');
    a.href = blobURL;
    a.download = `${name}.${type}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(blobURL);
};


export const bulkDownloadfile = (response: any, fileName: string) => {
    const filename = `${fileName}.xlsx`
    const url = window.URL.createObjectURL(new Blob([response]));
    const linkAnchor = document.createElement('a');
    linkAnchor.href = url;
    linkAnchor.setAttribute('download', filename);
    document.body.appendChild(linkAnchor);
    linkAnchor.click();
    linkAnchor.remove();
};